import React, { useEffect, useState } from 'react';
import { IconQuestionMark, Popover, useDeviceDetection } from '@gafe/common-ui';
import { loadSpace, SpaceApi } from '@usersnap/browser';
import classNames from 'classnames';

import { IconBug, IconComment } from '@/components/icons';
import { useAuth } from '@/hooks/useAuth';
import { EnvironmentService } from '@/services/Environment';
import { MediaType } from '@/types';
import { parseJwtPayload } from '@/utils/parse-jwt-payload';

import { SnapAction } from './SnapAction';
import { SnapWidgetProps } from './types';

import style from './SnapButton.module.scss';

const SnapWidget = ({ space }: SnapWidgetProps) => {
  return (
    <div className={style.snap_action_container}>
      <SnapAction
        icon={<IconComment />}
        projectKey={EnvironmentService.suggestionProjKey}
        space={space}
        text="Make a suggestion"
      />
      <SnapAction
        icon={<IconBug />}
        projectKey={EnvironmentService.debugProjKey}
        space={space}
        text="Report a bug"
      />
    </div>
  );
};

export const SnapButton = () => {
  const [snap, setSnap] = useState<SpaceApi | null>(null);
  const { userInfo } = useAuth();
  const media = useDeviceDetection();
  const userId = userInfo?.id;

  useEffect(() => {
    if (!userId) {
      return;
    }

    const apiKey = EnvironmentService.getUserSnapApiKey;
    const { email } = parseJwtPayload();
    const initial = {
      user: {
        userId: userId,
        email,
      },
    };

    // clear if user was logged in, then logout
    if (snap) {
      snap.init(initial).then();

      return;
    }

    loadSpace(apiKey)
      .then(api => setSnap(api))
      .catch();
  }, [userId, snap]);

  if (!snap || media === MediaType.Mobile) return null;

  return (
    <div className={style.snap_container}>
      <Popover
        classes={{
          popover: classNames(style.snap_popover, style.snap_overlay),
        }}
        openByClick
        placement="left-end"
        text={<SnapWidget space={snap} />}
      >
        <button className={style.snap_fab} type="button">
          <IconQuestionMark />
        </button>
      </Popover>
    </div>
  );
};
